import { Compass, TriangleAlert } from 'lucide-react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { BrandLogo } from '@/components/brand/BrandLogo';
import { Button } from '@/components/ui/button';

function Frame({
  icon: Icon,
  title,
  message,
  children,
}: {
  icon: typeof Compass;
  title: string;
  message: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-background px-6 text-center">
      <BrandLogo />
      <span className="inline-flex size-14 items-center justify-center rounded-full bg-brand-soft text-brand-strong dark:text-brand">
        <Icon className="size-7" aria-hidden />
      </span>
      <div>
        <h1 className="text-2xl font-extrabold">{title}</h1>
        <p className="mt-2 max-w-md text-sm text-muted-foreground">{message}</p>
      </div>
      {children}
    </div>
  );
}

export function NotFoundPage() {
  return (
    <Frame
      icon={Compass}
      title="Página não encontrada"
      message="O endereço não existe ou foi movido. Volte para o início e siga pelo menu."
    >
      <Button asChild>
        <Link to="/">Ir para o início</Link>
      </Button>
    </Frame>
  );
}

/** Erro inesperado ao renderizar uma rota: nunca mostra tela em branco. */
export function RouteErrorPage() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  console.error(error);
  return (
    <Frame
      icon={TriangleAlert}
      title="Algo deu errado nesta tela"
      message="Recarregue a página. Se o problema continuar, avise o suporte informando o que você estava fazendo."
    >
      <Button onClick={() => window.location.reload()}>Recarregar</Button>
    </Frame>
  );
}
